var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCabalModeList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5 99.7246C77.7744 99.7246 100 77.4556 100 50.2246C100 22.9502 77.7729 0.724609 50.5 0.724609C23.2271 0.724609 1 22.9517 1 50.2246C0.998504 77.4556 23.2256 99.7246 50.5 99.7246Z",
    fill: "#393E45",
    stroke: "black",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8061 31.6875H68.3997C69.5444 31.6875 70.4782 32.6212 70.4782 33.7241V63.8401C70.4782 64.9848 69.5444 65.9185 68.3997 65.9185H27.8061C26.7033 65.9185 25.7695 64.9848 25.7695 63.8401V33.7241C25.771 32.6212 26.7033 31.6875 27.8061 31.6875Z",
    fill: "#AE7911",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8061 28.2949H68.3997C69.5444 28.2949 70.4782 29.2287 70.4782 30.3734V60.4894C70.4782 61.6341 69.5444 62.5259 68.3997 62.5259H27.8061C26.7033 62.5259 25.7695 61.6356 25.7695 60.4894V30.3734C25.771 29.2287 26.7033 28.2949 27.8061 28.2949Z",
    fill: "#FFC74E",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8066 28.2949H68.4001C69.5449 28.2949 70.4786 29.2287 70.4786 30.3734V35.4206H25.7715V30.3734C25.7715 29.2287 26.7037 28.2949 27.8066 28.2949Z",
    fill: "#27282B",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.4918 33.4261C67.3822 33.4261 68.1468 32.6629 68.1468 31.7292C68.1468 30.8389 67.3837 30.0742 66.4918 30.0742C65.5581 30.0742 64.7949 30.8374 64.7949 31.7292C64.7964 32.6629 65.5596 33.4261 66.4918 33.4261Z",
    fill: "#171819"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.528 33.4261C62.4618 33.4261 63.1815 32.6629 63.1815 31.7292C63.1815 30.8389 62.4603 30.0742 61.528 30.0742C60.6377 30.0742 59.873 30.8374 59.873 31.7292C59.873 32.6629 60.6377 33.4261 61.528 33.4261Z",
    fill: "#171819"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.0607 70.8379L61.6562 71.9407L68.0607 70.8379L70.0554 74.5698L68.0607 70.8379Z",
    fill: "#27282B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0607 70.8379L61.6562 71.9407L68.0607 70.8379ZM68.0607 70.8379L70.0554 74.5698L68.0607 70.8379Z",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.0554 74.5698L68.0622 70.8379L61.6577 71.9407C60.4696 72.9583 59.1977 74.6132 58.5618 77.2858C58.0096 79.7458 57.8824 81.6552 57.9258 82.969C57.9677 84.624 58.2655 85.429 58.2655 85.429C58.2655 85.429 60.9799 85.429 65.7728 82.2058C69.8444 79.448 70.0988 75.8433 70.0569 74.8257C70.0554 74.6551 70.0554 74.5698 70.0554 74.5698Z",
    fill: "#AE7911",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.7087 51.9195C86.7696 59.9356 83.7155 62.9477 76.6736 69.9897L77.8617 70.9653L78.752 74.0194C79.1336 75.2494 78.752 77.2007 78.0308 78.0491L72.8129 84.1992L70.9469 78.727V76.3942L73.1526 73.5944C72.5585 74.1885 71.9645 74.7826 71.3704 75.4604L70.2676 74.6973L70.0551 74.5701L68.0619 70.8381L61.6575 71.9409C62.9728 70.8381 64.1594 70.4984 64.1594 70.4984L62.6331 69.4375C62.8456 69.014 63.0566 68.5891 63.2272 68.1656L60.0459 71.2616L54.2773 71.4741V69.1412L58.1799 64.4336C58.8592 63.5433 59.6224 62.8639 60.8524 62.6515L64.7968 62.0574L65.8144 62.6096C69.9294 53.5326 71.6248 49.7991 79.6005 47.7207C81.043 47.3391 82.6965 46.9994 84.6477 46.7031C85.158 48.6963 85.4977 50.3932 85.7087 51.9195Z",
    fill: "#27282B",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.6081 33.4261C57.4985 33.4261 58.2631 32.6629 58.2631 31.7292C58.2631 30.8389 57.5 30.0742 56.6081 30.0742C55.6744 30.0742 54.9531 30.8374 54.9531 31.7292C54.9531 32.6629 55.6744 33.4261 56.6081 33.4261Z",
    fill: "#171819"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7091 38.0508H58.3475C58.8563 38.0508 59.2812 38.4743 59.2812 39.0264V41.2321C59.2812 41.7842 58.8578 42.1658 58.3475 42.1658H38.7091C38.2003 42.1658 37.7754 41.7842 37.7754 41.2321V39.0264C37.7769 38.4743 38.2003 38.0508 38.7091 38.0508Z",
    fill: "#595E65",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7091 44.8789H58.3475C58.8563 44.8789 59.2812 45.3024 59.2812 45.8126V48.0602C59.2812 48.6124 58.8578 48.9939 58.3475 48.9939H38.7091C38.2003 48.9939 37.7754 48.6124 37.7754 48.0602V45.8126C37.7769 45.3024 38.2003 44.8789 38.7091 44.8789Z",
    fill: "#595E65",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.0716 52.6406H58.0945C58.6885 52.6406 59.1973 53.1075 59.1973 53.7435V56.416C59.1973 57.01 58.6885 57.5188 58.0945 57.5188H52.0716C51.4775 57.5188 50.9688 57.01 50.9688 56.416V53.7435C50.9688 53.1075 51.4775 52.6406 52.0716 52.6406Z",
    fill: "#298552",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.1856 66.4277L77.8581 68.6753L78.7065 72.5778C78.9609 73.8078 78.7485 74.8688 78.0272 75.7172L72.8094 81.8673L70.9434 76.3951L75.1856 66.4277Z",
    fill: "#595E65",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.809 61.3796L64.7968 59.7246L60.8524 60.3187C59.6224 60.5312 58.6887 61.1252 58.138 62.1008L54.2773 69.1428L60.0459 68.9303L67.809 61.3796Z",
    fill: "#595E65",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.6475 44.3711C69.8438 46.662 70.5232 50.819 62.6328 67.1489L71.3701 73.1299C83.799 59.8945 88.3794 58.9188 84.6475 44.3711Z",
    fill: "#595E65",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.4719 52.3874C77.7332 51.1574 75.2731 51.6242 74.085 53.4049C72.855 55.1871 73.3218 57.6037 75.0606 58.7919C76.8428 60.0219 79.3028 59.5984 80.4895 57.8162C81.721 56.0355 81.2541 53.6174 79.4719 52.3874Z",
    fill: "#FFC74E",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.1595 68.166C64.1595 68.166 59.8335 69.3107 58.5601 74.9521C57.2882 80.5515 58.2638 83.0968 58.2638 83.0968C58.2638 83.0968 60.9782 83.0968 65.7711 79.8736C70.5221 76.6505 70.0552 72.2391 70.0552 72.2391L67.1283 70.2026L64.1595 68.166Z",
    fill: "#FFC74E",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2852 63.6289L71.5815 68.6343",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.5977 45.3882L85.7059 49.587C85.4934 48.0607 85.1552 46.3638 84.6449 44.3691C82.6951 44.6669 81.0402 45.0066 79.5977 45.3882Z",
    fill: "#FFC74E",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3828 53.957L55.0797 55.6539L58.8551 51.1992",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.345 52.6406H45.0716C45.7076 52.6406 46.1745 53.1075 46.1745 53.7435V56.416C46.1745 57.01 45.7076 57.5188 45.0716 57.5188H39.345C38.751 57.5188 38.2422 57.01 38.2422 56.416V53.7435C38.2422 53.1075 38.751 52.6406 39.345 52.6406Z",
    fill: "#FFC74E",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8093 20.0645C22.3805 20.0645 17.9258 24.4758 17.9258 29.948C17.9258 35.4202 22.379 39.8315 27.8093 39.8315C33.2816 39.8315 37.7348 35.4202 37.7348 29.948C37.7348 24.4758 33.2816 20.0645 27.8093 20.0645Z",
    fill: "#144028",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8093 17.6914C22.3805 17.6914 17.9258 22.1446 17.9258 27.6168C17.9258 33.0457 22.379 37.5004 27.8093 37.5004C33.2816 37.5004 37.7348 33.0472 37.7348 27.6168C37.7363 22.1446 33.2816 17.6914 27.8093 17.6914Z",
    fill: "#298552",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M24.966 37.2012L24.7969 39.1105",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4636 28.8453C21.488 27.9116 21.488 26.3434 22.4217 25.4097C23.3973 24.434 24.9236 24.434 25.8993 25.3678L27.3837 26.8103L33.1941 19.9808C34.0844 18.9199 35.6122 18.7927 36.6717 19.6845C37.6892 20.5749 37.8164 22.1027 36.9679 23.1202L29.4172 32.0281L29.2901 32.1553C28.3563 33.1309 26.7881 33.1309 25.8125 32.1553L22.4636 28.8453Z",
    fill: "#144028",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7676 39.0684H46.8934C47.1897 39.0684 47.4021 39.2808 47.4021 39.5352V40.7233C47.4021 40.9777 47.1897 41.1902 46.8934 41.1902H39.7676C39.5133 41.1902 39.3008 40.9777 39.3008 40.7233V39.5352C39.3008 39.2808 39.5133 39.0684 39.7676 39.0684Z",
    fill: "#27282B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3994 39.0684H56.5251C56.7795 39.0684 56.992 39.2808 56.992 39.5352V40.7233C56.992 40.9777 56.7795 41.1902 56.5251 41.1902H49.3994C49.1031 41.1902 48.8906 40.9777 48.8906 40.7233V39.5352C48.8906 39.2808 49.1016 39.0684 49.3994 39.0684Z",
    fill: "#27282B"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3613 47.9339C40.9553 47.9339 41.4222 47.4671 41.4222 46.873C41.4222 46.3223 40.9553 45.8555 40.3613 45.8555C39.8091 45.8555 39.3438 46.3223 39.3438 46.873C39.3438 47.4671 39.8091 47.9339 40.3613 47.9339Z",
    fill: "#27282B"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5039 47.9339C44.0979 47.9339 44.5648 47.4671 44.5648 46.873C44.5648 46.3223 44.0979 45.8555 43.5039 45.8555C42.9532 45.8555 42.4863 46.3223 42.4863 46.873C42.4848 47.4671 42.9517 47.9339 43.5039 47.9339Z",
    fill: "#27282B"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.6386 47.9339C47.2327 47.9339 47.6996 47.4671 47.6996 46.873C47.6996 46.3223 47.2327 45.8555 46.6386 45.8555C46.088 45.8555 45.6211 46.3223 45.6211 46.873C45.6211 47.4671 46.088 47.9339 46.6386 47.9339Z",
    fill: "#27282B"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7792 47.9339C50.3733 47.9339 50.8402 47.4671 50.8402 46.873C50.8402 46.3223 50.3733 45.8555 49.7792 45.8555C49.2286 45.8555 48.7617 46.3223 48.7617 46.873C48.7617 47.4671 49.2271 47.9339 49.7792 47.9339Z",
    fill: "#27282B"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M40.998 53.8301L43.5853 56.4173",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5853 53.8301L40.998 56.4173",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4434 62.5254V65.9192",
    stroke: "#171819",
    strokeWidth: 0.763449,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCabalModeList);
export default __webpack_public_path__ + "static/media/cabal-mode-list.00eddc06e3060bec9efa6192a42b788c.svg";
export { ForwardRef as ReactComponent };